import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import khmRatings from "../../../../src/data/articles/cube-prospective-kaldheim/khm-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  khmRatings,
  ProspectiveIntro,
  React
};